import cx from 'classnames'
import React from 'react'

import type { ButtonProps } from './Button'
import { VARIANT_MAP } from './Button'
import styles from './Button.module.scss'

export const IconButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = 'primary',
      size = '2',
      warning = false,
      className,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <button
        className={cx(
          styles.button,
          styles[`button--${VARIANT_MAP[variant]}`],
          styles[`button--size${String(size)}`],
          styles.iconButton,
          className
        )}
        data-warning={warning}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    )
  }
)

IconButton.displayName = 'IconButton'
